import React, { useEffect } from "react";
import { StyleSheet, View, Text, Image, TouchableOpacity } from "react-native";

import { MaterialIcons, Entypo } from "@expo/vector-icons";
import uuidv4 from "../utils/uuidv4";
import { useNavigation } from "@react-navigation/core";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { serverDefaultUrl } from "../services/api";
import * as Print from "expo-print";
import { shareAsync } from 'expo-sharing';

const ModalPaperWalletDeposit = ({ handleCloseModal, handleCloseWithTransaction }) => {
  
  return (
    <>
      <View style={styles.headerLeft}>
        <MaterialIcons
          onPress={handleCloseModal}
          name="close"
          size={30}
          color="black"
        />

        {/* <Entypo
                    name="share"
                    size={30}
                    color="black"
                /> */}
      </View>

      <View style={styles.container}>
        <Image
          source={require("../../assets/success.png")}
          style={styles.image2}
        />
        <Text style={styles.text}>
          O depósito da Paper Wallet foi realizado com{" "}
          <Text style={styles.success}>sucesso!</Text>
        </Text>

        <TouchableOpacity
          onPress={() => {
            handleCloseWithTransaction();
          }}
        >
          <Text
            style={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: 12,
              marginTop: 100,
              textDecorationLine: "underline",
              color: "#228c9a",
              fontSize: 14,
            }}
          >
            FECHAR
          </Text>
        </TouchableOpacity>
        <Image
          source={require("../../assets/imgs/gpxcoinModal.png")}
          style={styles.cardCoin}
          resizeMode="contain"
        />
      </View>


    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "flex-start",
    alignItems: "center",
    padding: 75,
    marginTop: 35,
  },
  headerLeft: {
    marginTop: 25,
    padding: 15,
    // alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  headerRight: {
    marginTop: 25,
    padding: 15,
    alignItems: "flex-end",
  },
  image1: { width: "35%", height: "47%", resizeMode: "stretch" },
  image2: { width: 90, height: 90 },
  text: {
    fontSize: 18,
    marginTop: 30,
    textAlign: "center",
  },
  success: {
    fontWeight: "bold",
    color: "#1FBFB5",
  },
  cardCoin: {
    width: 250,
    position: "absolute",
    right: -80,
    bottom: -200,
  },
});

export default ModalPaperWalletDeposit;
